<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center">CONJUNCTIONS</h1>
<h2 class="center" style="margin-top:20px;">Bi-Annual Volumes of New Writing</h2>
<h3 class="center" style="margin-top:80px;"><i>Edited by</i></h3>
<h3 class="center">Bradford Morrow</h3>
<h3 class="center" style="margin-top:80px;"><i>Contributing Editors</i></h3>
<p class="center">John Ashbery</p>
<p class="center">Martine Bellen</p>
<p class="center">Mei-mei Berssenbrugge</p>
<p class="center">Mary Caponegro</p>
<p class="center">Brian Evenson</p>
<p class="center">William H. Gass</p>
<p class="center">Peter Gizzi</p>
<p class="center">Robert Kelly</p>
<p class="center">Ann Lauterbach</p>
<p class="center">Norman Manea</p>
<p class="center">Rick Moody</p>
<p class="center">Howard Norman</p>
<p class="center">Joan Retallack</p>
<p class="center">Joanna Scott</p>
<p class="center">David Shields</p>
<p class="center">Peter Straub</p>
<p class="center">John Edgar Wideman</p>
<p class="center" style="margin-top:40px;"><i>published by</i> Bard College</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// conjunctions.vue?2763b526